import { MerchantActions, EMerchantActions } from '../actions/merchant.actions';
import { initialMerchantState, IMerchantState } from '../states/merchant.state';

export const MerchantReducers = (
  state = initialMerchantState,
  action: MerchantActions
): IMerchantState => {
  switch (action.type) 
  {
    case EMerchantActions.GetMerchantSuccess: {
      return {
        ...state,
        Merchant:{...action.payload}
      };
    }
    default:
      return state;
  }
};
